import axios, { AxiosError, AxiosResponse } from 'axios';
import getVersionWebview from '../navigation/controlVersion';
import { TrackingEvents } from '../dataTransformation/tracking';

const { trackingApiRequest } = new TrackingEvents();
const TokenHandlerClient = axios.create({
    baseURL: '/th',
    withCredentials: true,
    headers: {
        'Content-type': 'application/json',
        'X-App-Info': getVersionWebview(),
    },
});

TokenHandlerClient.interceptors.response.use(
    (response: AxiosResponse) => {
        trackingApiRequest(response, 'SUCCESS');
        return response;
    },
    (error: AxiosError) => {
        trackingApiRequest(error, 'ERROR');
        return Promise.reject(error);
    },
);

export default TokenHandlerClient;
